// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"554":"4930f304","676":"1fbd7d60"}[chunkId] + ".chunk.js";
};